import { STooltip } from './Tooltip.styles';
import { TooltipProps } from './Tooltip.types';

export const Tooltip = ({ ...props }: TooltipProps) => {
  return <STooltip {...props} />;
};
